import React, { useEffect, useState } from "react";
 
import styled from "styled-components";

import MenuButton from "./MenuButton";
import { config } from "../../config";
import useAuth from '../../ContextProvider/AuthProvider';
import { PAWPRINT_USER_ROLE_KEY } from "../../Constant";
import { getCategoryDocument } from "../../../api/axios";
import { useLocation, useNavigate } from "react-router-dom";


function Menutool(props) {
  const { isOpen, munuRef } = props;
  const [categories, setCategories] = useState([]);
  const { user } = useAuth() || {};
  const { sidebar = [] } = config;
  const location = useLocation();
  let navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const savedDropdown = searchParams.get("categoryId");    
  const [openDropdown, setOpenDropdown] = useState(savedDropdown ? "Documents" : null);

  const role =
    user?.isSuperUser === "true"
      ? "SuperUser"
      : localStorage.getItem(PAWPRINT_USER_ROLE_KEY);

  let SidebarItems = sidebar.filter((item) => item.roles.includes(role));

  if (SidebarItems.length > 0) {
    SidebarItems = SidebarItems.map((item) => {
      if (item.title === "Documents") {
        return { ...item, subMenuItem: categories || [] };
      }
      return item;
    });
  }

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getCategoryDocument();
        setCategories(response.data.data || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const toggleDropdown = (title, event) => {
    event.stopPropagation(); // Prevent event bubbling to submenus
    event.preventDefault(); 
    setOpenDropdown((prevTitle) => 
      prevTitle === title ? null : title
    );
  };

  return (
    <Wrapper isOpen={isOpen} ref={munuRef}>
      {SidebarItems.map((item, i) => (
        <React.Fragment key={i}>
          <MenuButton item={item} toggleDropdown={toggleDropdown} openDropdown={openDropdown}/>
          {item.title === "Documents" &&  openDropdown === item.title && (
         <div className="sub-item-data">
         {item.subMenuItem?.map((category, catIndex) => {
            const urlParams = new URLSearchParams(location.search);
            const sub_category = urlParams.get('categoryId');
            const isActive = sub_category === String(category.id);
            return (
                <div key={catIndex} className="accordion-submenu-item">
                  <span className="accordion-item-sub-item">
                     <div className="accordion-item-border"></div>
                   </span>
              <div className={isActive ? 'submenu-active accordion-item' : 'submenu-item accordion-item'}  onClick={(event) => {
                event.stopPropagation();
                 navigate(`/document/category/${category.id}`);
              }}>{category.category}</div>
              </div>
             )
           })}
         </div>
          )}
        </React.Fragment>
      ))}
    </Wrapper>
  );
}

export default Menutool;
const Wrapper = styled.div`
  display: none;
  @media (max-width: 890px) {
    display: block;
    position: fixed;
    top: 59px;
    right: 0px;
    background: rgba(15, 14, 71, 0.3);
    box-shadow: 0px 50px 100px rgba(0, 0, 0, 0.25),
      inset 0px 0px 0px 0.5px rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(40px);
    border-radius: 20px;
    // padding: 10px;
    opacity: ${(props) => (props.isOpen ? 1 : 0)};
    visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
    z-index: 11;
    display: grid;
    gap: 1px;
    grid-template-columns: 200px;
    transition: 0.3s ease-in-out;
    overflow-y: auto;
    max-height: 80vh;
    }
     .sub-item-data{
        position: relative;
         margin-left: 20px;
         margin-top: -1px;
         margin-right: 20px;
      }
     .sub-item-data::after{
    position:absolute;
    width:1px;
    background:rgb(231, 231, 232);
    content: '';
    left:0;
   height: calc(100% - 10px);
   top: -9px;
    }
     .accordion-submenu-item{
    display: flex;
    align-items: center;
    }
     .accordion-item-border{
        width: 15px;
       border-bottom: 1px solid rgb(231, 231, 232);
        position: absolute;
      }
        .accordion-item{
       position: relative;
       border:1px solid rgb(231, 231, 232);
       width: 100%;
       padding: 5px;
       margin: 4px 16px;
       border-radius: 4px;
       &:hover {
       border:1px solid #000;
    }
        .submenu-active{
      padding: 12px 16px;
       background: #fff !important;
    color: #000;
}
  }
`;
